import DefaultModal from '../../../../components/Modal/DefaultModal';
import React, { useState, useEffect, useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import ProtocolService from '../../service';
import { toast } from 'react-toastify';
import { Row, Form, Col, Button } from 'reactstrap';
import FlexSelect from '../../../../components/Inputs/FlexSelect';

export const ModalNotificationAgent = ({
  isModalOpen,
  onModalToggle,
  protocolId,
  recordTypeId,
  onNewAgentSelected,
  ...props
}) => {
  const closeModal = useCallback(() => onModalToggle(false), [onModalToggle]);
  const [agentsList, setAgentsList] = useState([]);
  const { control, handleSubmit, errors, setValue } = useForm();

  useEffect(() => {
    const fetchAllUsersByRecordTypeId = async (recordTypeId) => {
      if (!recordTypeId) return;
      try {
        const response = await ProtocolService.getUsersByRecordTypeId(
          recordTypeId
        );
        const users = (response?.data || []).sort((a, b) => {
          if (a?.name.toLowerCase() < b?.name.toLowerCase()) return -1;
          if (a?.name.toLowerCase() > b?.name.toLowerCase()) return 1;
          return 0;
        });
        setAgentsList(users);
      } catch (err) {
        console.error(err);
        toast.error('Erro ao carregar os usuários', {
          autoClose: 3000,
          closeOnClick: true
        });
        closeModal();
      }
    };
    fetchAllUsersByRecordTypeId(recordTypeId);
  }, [closeModal, recordTypeId]);

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const onSubmit = async (data) => {
    try {
      await ProtocolService.updateNotificationAgent(protocolId, {
        new_agent_id: data.newNotificationAgentId
      });

      const newAgentSelected = agentsList.find(
        (agent) => agent.login === data.newNotificationAgentId
      );

      onNewAgentSelected(newAgentSelected?.name ?? '');
      toast.success('Agente de notificação atualizado com sucesso!', {
        autoClose: 3000,
        closeOnClick: true
      });
      closeModal();
    } catch (err) {
      console.error(err);
      toast.error('Erro ao atualizar o agente de notificação.', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Alterar responsável do protocolo"
      showCloseButton={false}
      modalContainerClasses="modal-sm"
      {...props}
    >
      <>
        <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Col md="12">
              <label className="form-control-label">Agentes*</label>
              <Controller
                render={(props) => (
                  <FlexSelect
                    isClearable={true}
                    dataOptions={agentsList}
                    isMulti={false}
                    closeMenuOnSelect={true}
                    value={props.value}
                    valueController={setValue}
                    fieldName="newNotificationAgentId"
                    labelName="name"
                    valueName="login"
                  />
                )}
                control={control}
                name="newNotificationAgentId"
                rules={{ required: 'Status é obrigatório!' }}
                defaultValue=""
              />
              <ErrorMessage
                errors={errors}
                name="newNotificationAgentId"
                render={({ message }) => errorFormMessage(message)}
              />
            </Col>
          </Row>
          <hr />
          <Button color="primary" type="submit">
            Salvar
          </Button>
          <Button color="danger" onClick={closeModal}>
            Voltar
          </Button>
        </Form>
      </>
    </DefaultModal>
  );
};
